import PageMeta from '@/components/PageMeta';
import { Link } from 'react-router-dom';

export default function AccountDeletion() {
  return (
    <div>
      <PageMeta
        title="Account deletion"
        description="How to request deletion of your Valanti Labs account."
      />
      <section className="vl-container py-16 lg:py-24 max-w-3xl">
        <p className="mono-label text-vl-violet">Support · Account deletion</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mt-5 text-vl-ink">
          Requesting account deletion.
        </h1>
        <p className="mt-6 text-lg text-vl-ink/70 leading-relaxed">
          Once the Valanti Labs application is publicly available, you will be able to begin an account-deletion
          request from within the app and from this page.
        </p>
      </section>

      <section className="bg-vl-bg2 border-y hairline">
        <div className="vl-container py-16 lg:py-20 max-w-3xl space-y-10">
          <Block title="How to begin a deletion request">
            <p>
              The fastest path will be from within the application itself, under Settings. From this page, you can
              also send a deletion request via the contact form — please select the topic "Privacy".
            </p>
          </Block>
          <Block title="Information we may need to verify your identity">
            <p>
              To protect your account, we may ask you to confirm the email address linked to the account and to
              answer a small number of identity-verification questions. We will not ask for sensitive health
              information as part of this verification process.
            </p>
          </Block>
          <Block title="What happens after a deletion request">
            <p>
              Once a verified deletion request is processed, your account and associated movement-analysis records
              will be removed from active systems. Some information may be retained where required for legal,
              operational, security or fraud-prevention reasons. The exact retention exceptions and timeframes will
              match the final privacy policy.
            </p>
            <p>
              Deletion of your account does not always result in instant deletion of every record. We will explain
              clearly what is removed, what may be retained, and for how long.
            </p>
          </Block>
          <Block title="Contacting support">
            <p>
              For any question about deletion, please use the contact form on this site. A monitored support mailbox
              will be added here once it has been created and confirmed active.
            </p>
            <div className="mt-4">
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 rounded-full bg-vl-ink text-vl-bg px-5 py-3 text-sm font-medium hover:bg-vl-violet transition-colors"
              >
                Open the contact form
              </Link>
            </div>
          </Block>

          <p className="text-sm text-vl-ink/55 leading-relaxed border-t hairline pt-6">
            This page is provided as a stable public URL suitable for App Store and Google Play references. The final
            wording is subject to legal and technical review before publication.
          </p>
        </div>
      </section>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-serif-display text-2xl text-vl-ink">{title}</h2>
      <div className="mt-3 space-y-3 text-vl-ink/75 leading-relaxed">{children}</div>
    </div>
  );
}
